import React, { useEffect, useState } from 'react'
import { Button } from 'semantic-ui-react'
import './ScrollTop.css'

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false)

  // Show button when page is scorlled upto given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)
  }, [])

  return (
    <div className="scroll-to-top">
      {isVisible && (
        <Button className="ui is-secondary button" onClick={scrollToTop}>
          Top
        </Button>
      )}
    </div>
  )
}
